import { Link } from 'react-router-dom';
import { SITE } from '../../config/site';
import { SEO_PAGES } from '../../config/seo';
import { Breadcrumbs } from '../../components/ui/Breadcrumbs';
import { Seo } from '../../components/seo';
import { buildBreadcrumbJsonLd } from '../../seo/buildBreadcrumbJsonLd';
import styles from './FoodPrintingPage.module.css';

const PAPER_TYPES = [
  { name: 'Вафельная бумага', price: '140 ₽', note: 'заливка менее 50%' },
  { name: 'Плотная глянцевая вафельная бумага', price: '190 ₽' },
  { name: 'Сахарная бумага', price: '290 ₽' },
];

const LAYOUT_REQUIREMENTS = [
  'Файл в пропорциях А4 — 210 × 297 мм (2480 × 3508 px), формат JPG.',
  'Для сахарной бумаги нужен верхний отступ 1,5 см.',
  'Рекомендуемая плотность — 300 ppi. Качество зависит от макета.',
  'При заливке более 80% можем отказать в печати.',
  'Магазин не отвечает за отображение индивидуальных макетов на готовом листе.',
];

export function FoodPrintingPage() {
  const seo = SEO_PAGES.foodPrinting;
  const breadcrumbs = [
    { label: 'Главная', to: '/' },
    { label: 'Пищевая печать', to: '/food-printing' },
  ];

  return (
    <div className={`container ${styles.page}`}>
      <Seo
        title={seo.title}
        description={seo.description}
        path={seo.path}
        jsonLd={buildBreadcrumbJsonLd(breadcrumbs)}
      />

      <Breadcrumbs items={breadcrumbs} />

      <h1 className={styles.title}>Пищевая печать для тортов в {SITE.city}е</h1>

      <div className={styles.content}>
        <p>
          Фотопечать на пищевой бумаге для украшения тортов и десертов: вафельной, плотной
          глянцевой вафельной и сахарной. В цену входят печать и лист формата А4 — удобно для
          домашних кондитеров и праздничной выпечки.
        </p>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Стоимость</h2>

          <div className={styles.tableWrap}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>Вид бумаги</th>
                  <th>Цена</th>
                </tr>
              </thead>
              <tbody>
                {PAPER_TYPES.map(({ name, price, note }) => (
                  <tr key={name}>
                    <td>
                      {name}
                      {note && <span className={styles.rowNote}> — {note}</span>}
                    </td>
                    <td>{price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Требования к макету</h2>
          <ul className={styles.list}>
            {LAYOUT_REQUIREMENTS.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Как заказать</h2>
          <p>
            Отправьте макет на{' '}
            <a href={`mailto:${SITE.email}`}>{SITE.email}</a>. Оплата и печать — в{' '}
            <Link to="/retail-store">розничном магазине</Link> по адресу{' '}
            <a href={SITE.mapsUrl} target="_blank" rel="noopener noreferrer">
              {SITE.address}
            </a>
            .
          </p>
        </section>
      </div>
    </div>
  );
}
